import { isNotNilOrEmpty } from '../../value/isNotNilOrEmpty';
/**
 * Escapes a string intended to be used as a literal for a Regular Expression
 *
 * @since v2.37.0
 * @category String
 * @param {string} value The original string to escape
 * @returns {string}
 * @example
 * const escaped = escapeRegEx('** Hello World **');
 * //=> '\*\* Hello World \*\*'
 *
 * const regEx = new RegExp(escaped, 'g');
 * // Do regex matching...
 * @docgen_example
 * escapeRegEx('** Hello World **');
 */
export var escapeRegEx = function (value) {
    return isNotNilOrEmpty(value) && ['string', 'number'].indexOf(typeof value) >= 0
        ? value.toString().replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        : '';
};
